import { render, staticRenderFns } from "./AddSettlementItemAmountModal.vue?vue&type=template&id=4f5be4f4&"
import script from "./AddSettlementItemAmountModal.vue?vue&type=script&lang=js&"
export * from "./AddSettlementItemAmountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports